const externalInits = () => {
    // slick.js
    if ( $('.js-hero-section-image-slider').length ) {
        $('.js-hero-section-image-slider').slick({
            dots: true,
            appendDots: $('.hero-section__image-gallery-controls'),
            dotsClass: 'slick-dots | d-flex order-2',
            arrows: true,
            prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
            nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
            appendArrows: $('.hero-section__image-gallery-controls'),
            autoplay: true,
            autoplaySpeed: 4000,
            fade: true,
            speed: 1100,
            cssEase: 'linear'
        });
    }

    if ( $('.js-testimonials-slider').length ) {
        $('.js-testimonials-slider').slick({
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4250,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
		});
    }

    if ( $('.js-cta-slider').length ) {
        $('.js-cta-slider').slick({
            dots: true,
            appendDots: $('.cta-slider__image-gallery-controls'),
            dotsClass: 'slick-dots | d-flex order-2',
            arrows: true,
            prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
            nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
            appendArrows: $('.cta-slider__image-gallery-controls'),
            // autoplay: true,
            mobileFirst: true,
            responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 2
                }
            }]            
        });
    }

    if ( $('.js-grid-items-slider--small').length ) {
        const gridItemsSlider = $('.js-grid-items-slider--small');
		const settings = {
            dots: false,
            arrows: false,
            autoplay: false,
            infinite: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
		};
        
        if ( $(window).width() < 992 ) {
		    gridItemsSlider.slick(settings);
        }

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ( $(window).width() > 991 ) {
				if (gridItemsSlider.hasClass('slick-initialized')) {
					gridItemsSlider.slick('unslick');
				}
				return;
			}

			if ( $(window).width() < 992 ) {
				if (!gridItemsSlider.hasClass('slick-initialized')) {
					return gridItemsSlider.slick(settings);
				}
			}
		});
    } 
    
    if ( $('.js-grid-items-slider--large').length ) {
        const gridItemsSlider = $('.js-grid-items-slider--large');
		const settings = {
            dots: false,
            arrows: false,
            autoplay: false,
            infinite: false
		};
        
        if ( $(window).width() < 768 ) {
		    gridItemsSlider.slick(settings);
        }

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ( $(window).width() > 767 ) {
				if (gridItemsSlider.hasClass('slick-initialized')) {
					gridItemsSlider.slick('unslick');
				}
				return;
			}

			if ( $(window).width() < 768 ) {
				if (!gridItemsSlider.hasClass('slick-initialized')) {
					return gridItemsSlider.slick(settings);
				}
			}
		});
    } 
    
    if ( $('.js-cs-block-slider') ) {
        const csBlockSlider = $('.js-cs-block-slider');
		const settings = {
            dots: false,
            arrows: false,
            autoplay: false,
            infinite: false,
            draggable: false,
            swipe: false,
            fade: true,
            speed: 1000
		};
        
        if ( $(window).width() > 991 ) {
		    csBlockSlider.slick(settings);
        }

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ( $(window).width() < 992 ) {
				if (csBlockSlider.hasClass('slick-initialized')) {
					csBlockSlider.slick('unslick');
				}
				return;
			}

			if ( $(window).width() > 991 ) {
				if (!csBlockSlider.hasClass('slick-initialized')) {
					return csBlockSlider.slick(settings);
				}
			}
		});
    }

    if ( $('.js-gallery-slider').length ) {
        $('.js-gallery-slider').slick({
            dots: true,
            appendDots: $('.gallery-slider__image-gallery-controls'),
            dotsClass: 'slick-dots | d-flex order-2',
            arrows: true,
            prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
            nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
            appendArrows: $('.gallery-slider__image-gallery-controls'),
            mobileFirst: true,
            responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    draggable: false,
                    swipe: false
                }
            }]
        });        
    }

    if ( $('.js-single-page-image-slider').length ) {
        $('.js-single-page-image-slider').slick({
            dots: true,
            appendDots: $('.image-gallery__image-gallery-controls'),
            dotsClass: 'slick-dots | d-flex order-2',
            arrows: true,
            prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
            nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
            appendArrows: $('.image-gallery__image-gallery-controls'),
        });        
    }

    // Rooms & Suites
    roomsSuitesSliderInits();

    // Dining Options
    diningOptionsSliderInits();

    // Event Spaces
    if ( $('.js-event-spaces-space-slider') ) {
        const eventSpacesSlider = $('.js-event-spaces-space-slider');
		const settings = {
            dots: false,
            arrows: false,
            autoplay: false,
            infinite: false,
            draggable: false,
            swipe: false
		};
        
        if ( $(window).width() > 991 ) {
		    eventSpacesSlider.slick(settings);
        }

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ( $(window).width() < 992 ) {
				if (eventSpacesSlider.hasClass('slick-initialized')) {
					eventSpacesSlider.slick('unslick');
				}
				return;
			}

			if ( $(window).width() > 991 ) {
				if (!eventSpacesSlider.hasClass('slick-initialized')) {
					return eventSpacesSlider.slick(settings);
				}
			}
		});
    }

    // Event Spaces Image
    eventsSpacesSliderInits();

    /* Modaal */
    $('.js-iframe-popup').modaal({
        type: 'iframe',
        width: 888,
        height: 500
    });
};

const getSliderArrows = (arrowType) => {
    const prevArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="53.659" height="15.713" viewBox="0 0 53.659 15.713" class="e-svg"><g data-name="Group 254" transform="translate(931.463 669.354) rotate(180)"><path data-name="Path 304" d="M-14740.8-11535h52.952" transform="translate(15618.6 12196.499)" fill="none" stroke="#f7dbbb" stroke-width="1" class="e-svg__stroke"/><path data-name="Path 305" d="M-14662.4-11562.444l7.5,7.5-7.5,7.5" transform="translate(15577.904 12216.438)" fill="none" stroke="#f7dbbb" stroke-width="1" class="e-svg__stroke"/><path data-name="Path 306" d="M-14662.4-11562.444l7.5,7.5-7.5,7.5" transform="translate(15581.904 12216.438)" fill="none" stroke="#f7dbbb" stroke-width="1" class="e-svg__stroke"/><path data-name="Path 307" d="M-14662.4-11562.444l7.5,7.5-7.5,7.5" transform="translate(15585.656 12216.438)" fill="none" stroke="#f7dbbb" stroke-width="1" class="e-svg__stroke"/></g></svg>';
    const nextArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="53.659" height="15.713" viewBox="0 0 53.659 15.713" class="e-svg"><g data-name="Group 253" transform="translate(-877.804 -653.641)"><path data-name="Path 304" d="M-14740.8-11535h52.952" transform="translate(15618.6 12196.499)" fill="none" stroke="#f7dbbb" stroke-width="1" class="e-svg__stroke"/><path data-name="Path 305" d="M-14662.4-11562.444l7.5,7.5-7.5,7.5" transform="translate(15577.904 12216.438)" fill="none" stroke="#f7dbbb" stroke-width="1" class="e-svg__stroke"/><path data-name="Path 306" d="M-14662.4-11562.444l7.5,7.5-7.5,7.5" transform="translate(15581.904 12216.438)" fill="none" stroke="#f7dbbb" stroke-width="1" class="e-svg__stroke"/><path data-name="Path 307" d="M-14662.4-11562.444l7.5,7.5-7.5,7.5" transform="translate(15585.656 12216.438)" fill="none" stroke="#f7dbbb" stroke-width="1" class="e-svg__stroke"/></g></svg>';

    if ( arrowType == 'prev' ) {
        return prevArrow;
    }
    if ( arrowType == 'next' ) {
        return nextArrow;
    }

    return ''; // Return an empty string if no matches for arrowType
}

const roomsSuitesSliderInits = () => {
    if ( $('.js-rooms-suites-image-slider').length ) {
        var i = 1; $('.js-rooms-suites-image-slider').each(function() {
			$(this).addClass('js-rooms-suites-image-slider-'+i);

			$('.js-rooms-suites-image-slider-'+i).slick({
                dots: true,
                appendDots: $(this).siblings('.rooms-suites__post-gallery-controls'),
                dotsClass: 'slick-dots | d-flex order-2',
                arrows: true,
                prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
                nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
                appendArrows: $(this).siblings('.rooms-suites__post-gallery-controls'),
                autoplay: true,
                autoplaySpeed: 3250,
                fade: true,
                speed: 800,
                cssEase: 'linear'
			});

			i++;
		});
    }
}

const diningOptionsSliderInits = () => {
    if ( $('.js-dining-options-image-slider').length ) {
        var i = 1; $('.js-dining-options-image-slider').each(function() {
			$(this).addClass('js-dining-options-image-slider-'+i);

			$('.js-dining-options-image-slider-'+i).slick({
                dots: true,
                appendDots: $(this).siblings('.dining-options__post-gallery-controls'),
                dotsClass: 'slick-dots | d-flex order-2',
                arrows: true,
                prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
                nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
                appendArrows: $(this).siblings('.dining-options__post-gallery-controls'),
                autoplay: true,
                autoplaySpeed: 3250,
                fade: true,
                speed: 800,
                cssEase: 'linear'
			});

			i++;
		});
    }
}

const eventsSpacesSliderInits = () => {
    if ( $('.js-event-spaces-image-slider').length ) {
        var i = 1; $('.js-event-spaces-image-slider').each(function() {
			$(this).addClass('js-event-spaces-image-slider-'+i);

			$('.js-event-spaces-image-slider-'+i).slick({
                dots: true,
                appendDots: $(this).siblings('.event-spaces__space-gallery-controls'),
                dotsClass: 'slick-dots | d-flex order-2',
                arrows: true,
                prevArrow: '<div class="slick-arrow slick-prev | order-1">'+getSliderArrows('prev')+'</div>',
                nextArrow: '<div class="slick-arrow slick-next | order-3">'+getSliderArrows('next')+'</div>',
                appendArrows: $(this).siblings('.event-spaces__space-gallery-controls'),
                autoplay: true,
                autoplaySpeed: 3250,
                fade: true,
                speed: 800,
                cssEase: 'linear'
			});

			i++;
		});
    }
}
